var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":"primary","size":"lg","disabled":_setup.buttonDisabled},on:{"click":_setup.openDrawer}},[_c('i',{staticClass:"fa fa-cash-register mr-2"}),_vm._v(" "+_vm._s(_vm.$t('message.settings.openDrawer'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }